import gql from 'graphql-tag'

export const UPDATE_FILELIST = gql`
  mutation UpdateFileList($input: UpdateFileListInput!) {
    updateFileList(input: $input) {
      isSuccessful
      message
      errorCode
      errorName
      status
      updateFileList {
        message
      }
    }
  }
`

export const SET_UPLOAD_MEDIA = gql`
  mutation SetUploadMedia($input: SetUploadMediaInput!) {
    setUploadMedia(input: $input) {
      isSuccessful
      message
      setUploadMedia {
        message
        data {
          downloadId
          endTime
          downloadOn
          startTime
          identifier
          channel
          mediaFilename
          status
          url
          vehicleId
        }
      }
    }
  }
`

export const SET_ALARM_EVIDENCE = gql`
  mutation SetAlarmEvidence($input: SetAlarmEvidenceInput!) {
    setAlarmEvidence(input: $input) {
      isSuccessful
      message
      setAlarmEvidence {
        rawAlertId
        mediaFiles {
          fileType
          url
        }
      }
    }
  }
`

export const SET_DEVICE_STREAM = gql`
  mutation SetDeviceStream($input: SetDeviceStreamInput!) {
    setDeviceStream(input: $input) {
      isSuccessful
      message
      status
      setDeviceStream {
        message
      }
    }
  }
`

export const SET_VIDEO_STREAM_STATUS = gql`
  mutation SetVideoStreamStatus($input: SetVideoStreamStatusInput!) {
    setVideoStreamStatus(input: $input) {
      isSuccessful
      message
      setVideoStreamStatus {
        imei
        status
        channelSent
        channelNotSent
      }
    }
  }
`

export const SET_VIDEO_STREAM_STATUS_OFF = gql`
  mutation SetVideoStreamStatusOff {
    setVideoStreamStatusOff {
      isSuccessful
      errorCode
      errorName
      message
      status
      setVideoStreamStatusOff {
        status
      }
    }
  }
`

export const WAKE_UP_DEVICE = gql`
  mutation WakeDevice($input: WakeDeviceInput!) {
    wakeDevice(input: $input) {
      isSuccessful
      message
      status
      wakeDevice {
        message
      }
    }
  }
`
